import { useState } from 'react'
import H2Title from '../public/h2Title'
import Chart from './chart'
import GenDuo from '../public/genduo'
import NavLink from '../navLink'
import useMediaQuery from '../../hooks/useMediaQuery'

const Ltyw = ({ impNewsList = {}, imgNews = [], isTitleShow = true }) => {
  const [status, setStatus] = useState(1)
  const isMobile = useMediaQuery()

  const { channel = [], list1 = [], list2 = [] } = impNewsList || {}
  const [channel1, channel2] = channel || []

  const onClick = state => () => setStatus(state)

  if (isMobile) {
    return (
      <div className="flex mt-20 flex-col lg:flex-row">
        {/* <div className="w-full lg:w-[478px] flex items-center justify-center lg:justify-start">
          <H2Title border="b" title={channel2?.name} />
        </div>
        <div className="p-5 lg:p-0">
          <NavLink
            className="mt-[30px] block font-alhpr text-xl text-[#333333]"
            to={`/wzxq/id/${list2[0]?.id}`}
          >
            {list2[0]?.title}
          </NavLink>
          <p className="mt-[22px] font-sourceHan text-sm text-[#555555] line-clamp-3">
            {list2[0]?.description}
          </p>
          <div className="mt-[41px] border-t border-[#E7E7E7] pt-[35px]">
            {list2.map(({ title = '', id, outlink }, key) => {
              if (key) {
                return (
                  <NavLink
                    key={key}
                    className="font-alhpr text-xl text-[#333333] leading-[36px] block truncate"
                    to={outlink || `/wzxq/id/${id}`}
                    isOutLink={!!outlink}
                  >
                    {title}
                  </NavLink>
                )
              }
              return null
            })}
          </div>
          <div className="flex justify-center mt-8">
            <GenDuo
              href={`/hyjj/channel_id/${(status === 1 ? channel1 : channel2)?.id}`}
              className="mx-auto bg-[#0189D5] px-6 py-2 rounded-xl text-white"
            />
          </div>
        </div> */}
        <div className="lg:ml-10 lg:w-[472px]">
          <div className="w-full lg:w-[478px] flex items-center justify-center lg:justify-start">
            <H2Title border="b" title={channel1?.name} />
          </div>
          <Chart data={imgNews} pagePosition="left" className="w-full mt-8" />
          <div className="p-5 lg:p-0">
            <NavLink
              className="mt-[30px] block font-alhpr text-xl text-[#333333]"
              to={`/wzxq/id/${list1[0]?.id}`}
            >
              {list1[0]?.title}
            </NavLink>
            <p className="mt-[22px] font-sourceHan text-sm text-[#555555] line-clamp-3">
              {list1[0]?.description}
            </p>
            <div className="mt-[41px] border-t border-[#E7E7E7] pt-[35px]">
              {list1.map(({ title = '', id, outlink }, key) => {
                if (key) {
                  return (
                    <NavLink
                      key={key}
                      className="font-alhpr text-xl text-[#333333] leading-[36px] block truncate"
                      to={outlink || `/wzxq/id/${id}`}
                      isOutLink={!!outlink}
                    >
                      {title}
                    </NavLink>
                  )
                }
                return null
              })}
            </div>
            <div className="flex justify-center mt-8">
              <GenDuo
                href={`/hyjj/channel_id/${(status === 1 ? channel1 : channel2)?.id}`}
                className="mx-auto bg-[#0189D5] px-6 py-2 rounded-xl text-white"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="flex mt-20 flex-col lg:flex-row">
      {isMobile ? null : (
        <Chart
          data={imgNews}
          className="h-full lg:h-[450px] lg:w-[680px]"
          width="680px"
          height="450px"
          pagePosition="left"
        />
      )}
      <div className="lg:ml-10 lg:w-[472px]">
        <div className="w-full lg:w-[478px] flex items-center justify-center lg:justify-start">
          {isTitleShow && (
            <>
              <H2Title
                className={`${status === 1 && 'border-b-[5px]'} cursor-pointer`}
                onClick={onClick(1)}
                border="b"
                title={channel1?.name}
              />
              {isMobile && (
                <H2Title
                  onClick={onClick(2)}
                  className={`ml-20 ${status === 2 && 'border-b-[5px]'} cursor-pointer`}
                  title={channel2?.name}
                />
              )}
              {isMobile ? null : (
                <GenDuo
                  href={`/hyjj/channel_id/${(status === 1 ? channel1 : channel2)?.id}`}
                  className="ml-auto"
                />
              )}
            </>
          )}
        </div>
        {isMobile ? <Chart data={imgNews} pagePosition="left" className="w-full mt-8" /> : null}
        <div className="p-5 lg:p-0">
          <NavLink
            className="mt-[30px] block font-alhpr text-xl text-[#333333]"
            to={`/wzxq/id/${(status === 1 ? list1 : list2)[0]?.id}`}
          >
            {(status === 1 ? list1 : list2)[0]?.title}
          </NavLink>
          <p className="mt-[22px] font-sourceHan text-sm text-[#555555] line-clamp-3">
            {(status === 1 ? list1 : list2)[0]?.description}
          </p>
          <div className="mt-[41px] border-t border-[#E7E7E7] pt-[35px]">
            {(status === 1 ? list1 : list2).map(({ title = '', id, outlink }, key) => {
              if (key) {
                return (
                  <NavLink
                    key={key}
                    className="font-alhpr text-xl text-[#333333] leading-[36px] block truncate"
                    to={outlink || `/wzxq/id/${id}`}
                    isOutLink={!!outlink}
                  >
                    {title}
                  </NavLink>
                )
              }
              return null
            })}
          </div>
          {isMobile ? (
            <div className="flex justify-center mt-8">
              <GenDuo
                href={`/hyjj/channel_id/${(status === 1 ? channel1 : channel2)?.id}`}
                className="mx-auto bg-[#0189D5] px-6 py-2 rounded-xl text-white"
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default Ltyw
